import { useReducer } from "react";

export type InsuranceReportErrorFormFields =
  | "submitted"
  | "from"
  | "title"
  | "caseNumber"
  | "message"

export interface InsuranceReportErrorFormState {
  submitted: boolean
  message: string,
};

interface InsuranceReportErrorFormAction {
  type: "update" | "clear",
  field: InsuranceReportErrorFormFields
  payload?: any;
}

const reducer = (state: InsuranceReportErrorFormState, action: InsuranceReportErrorFormAction) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        [action.field]: action.payload,
      };
    case "clear":
      return {
        ...state,
        [action.field]: {},
      };
    default:
      return state;
  }
};

export const useInsuranceReportErrorForm = () => {
  const [state, dispatch] = useReducer(reducer, {
    submitted: false,
    message: ''
  });

  return { state, dispatch };
};
